import { useEffect } from "react";

// Adds `.is-in` to every `.s-reveal` block the first time it scrolls into view.
export const useReveal = (deps = []) => {
  useEffect(() => {
    const els = document.querySelectorAll(".site .s-reveal:not(.is-in), .site .s-sec:not(.is-in)");
    if (!els.length) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("is-in"));
      return undefined;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
